import React, { useState, useContext, useEffect } from 'react'
import { Table, Switch, Radio, Select, Col, Checkbox, Row, Input, Button } from 'antd';
import { TokenVerificationLoggedin, ScreenView, Block_U_Admin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";

const BasicSetting = () => {
    const loadingContext = useContext(LoadingContext);
    const [checkRole, setCheckRole] = useState("admin")
    const [initialValues, setInitialValues] = useState(null);
    const [isDirty, setIsDirty] = useState(false);

    const [initialPubData, setInitialPubData] = useState(null);

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        Block_U_Admin()


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)


            axios
                .get((configData.SERVER_URL + "ops/getPubDetails?_id="), {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setRegulationTool(response?.data?.data?.regulation_brand_safety_tool || "")
                    // setRegulationAdserver(response?.data?.data?.regulation_brand_safety_adserver || "")
                    setRegulationParameter(response?.data?.data?.regulation_brand_safety_regulator || [])
                    setRegulationParameterOther(response?.data?.data?.regulation_brand_safety_regulator_other || "")

                    const apiData = response?.data?.data || {};
                    // setInitialPubData(sanitizePubData(apiData));
                    setInitialPubData(apiData);



                    const initial = {
                        regulationTool: response?.data?.data?.regulation_brand_safety_tool || "",
                        regulationParameter: response?.data?.data?.regulation_brand_safety_regulator || [],
                        regulationParameterOther: response?.data?.data?.regulation_brand_safety_regulator_other || ""
                    };
                    setInitialValues(initial);
                })
                .catch((error) => {
                    notifyfailure("Failed to fetch the publisher details.")
                });
        }

        loadingContext.done()
    }, [loadingContext]);



    const [tab, setTab] = useState("basicsettings")
    const [buttonValue, setButtonValue] = useState(false);

    const [regulationTool, setRegulationTool] = useState("");
    const [regulationToolIsRequiredError, setRegulationToolIsRequiredError] = useState(false);
    // const [regulationAdserver, setRegulationAdserver] = useState("");
    // const [regulationAdserverIsRequiredError, setRegulationAdserverIsRequiredError] = useState(false);
    const [regulationParameter, setRegulationParameter] = useState([]);
    const [regulationParameterIsRequiredError, setRegulationParameterIsRequiredError] = useState(false);
    const [regulationParameterOther, setRegulationParameterOther] = useState("");
    const [regulationParameterOtherIsRequiredError, setRegulationParameterOtherIsRequiredError] = useState(false);


    function onChangeRegulationTool(event) {
        setRegulationToolIsRequiredError(false);
        setRegulationTool(event.target.value);
    }

    function onBlurRegulationTool(event) {
        if (event.target.value.trim().length === 0) {
            setRegulationToolIsRequiredError(true);
        }
        setRegulationTool(event.target.value.trim());
    }

    // function onChangeRegulationAdserver(event) {
    //     setRegulationAdserverIsRequiredError(false);
    //     setRegulationAdserver(event.target.value);
    // }

    // function onBlurRegulationAdserver(event) {
    //     if (event.target.value.trim().length === 0) {
    //         setRegulationAdserverIsRequiredError(true);
    //     }
    //     setRegulationAdserver(event.target.value.trim());
    // }

    function onChangeRegulationParameter(event) {
        if (event.length === 0) {
            setRegulationParameterIsRequiredError(true)
        }
        else {
            setRegulationParameterIsRequiredError(false)
        }
        if (!event.includes("Others")) setRegulationParameterOtherIsRequiredError(false);
        setRegulationParameter(event)
    }


    const normalizeArray = (arr = []) =>
        [...arr].sort();

    useEffect(() => {
        if (!initialValues) return;

        const hasChanged =
            regulationTool !== initialValues.regulationTool ||
            regulationParameterOther !== initialValues.regulationParameterOther ||
            JSON.stringify(normalizeArray(regulationParameter)) !== JSON.stringify(normalizeArray(initialValues.regulationParameter));

        setIsDirty(hasChanged);
    }, [regulationTool, regulationParameter, regulationParameterOther, initialValues]);

    const objectToFormData = (obj) => {
        const formData = new FormData();

        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        return formData;
    };

    // const REMOVE_KEYS = [
    //     "_id",
    //     "email",
    //     "role",
    //     "status",
    //     "pix_updatedAt",
    //     "combinedObj",
    //     "px_adk",
    //     "partial",
    //     "onboarding",
    //     "onboard_filled",
    //     "isPub",
    //     "a_manager"
    // ];

    // const sanitizePubData = (data) => {
    //     const clone = structuredClone(data);

    //     REMOVE_KEYS.forEach((key) => delete clone[key]);

    //     return clone;
    // };

    const buildFinalPayload = () => {
        if (!initialPubData) return null;

        return {
            ...initialPubData, // ✅ ALL keys preserved

            // 🔥formatted keys
            im: JSON.stringify(initialPubData.im),
            defineYourself: JSON.stringify(initialPubData.defineYourself),
            inventory_type_select: JSON.stringify(initialPubData.inventory_type_select),
            ad_format_monetise: JSON.stringify(initialPubData.ad_format_monetise),
            ad_format_monetise_other: JSON.stringify(initialPubData.ad_format_monetise_other),
            integration_type: JSON.stringify(initialPubData.integration_type),
            ortb_type: JSON.stringify(initialPubData.ortb_type),
            vast_type: JSON.stringify(initialPubData.vast_type),
            integration_protocol_rich_media_creative: JSON.stringify(initialPubData.integration_protocol_rich_media_creative),
            blockCategory: JSON.stringify(initialPubData.blockCategory),
            bcate_data: JSON.stringify(initialPubData.bcate_data),

            inventoryWebsiteData: initialPubData.inventory_type_select.includes("Website") ? JSON.stringify(initialPubData.inventoryWebsiteData) : [],
            inventoryMobileData: initialPubData.inventory_type_select.includes("Mobile App (Android / iOS)") ? JSON.stringify(initialPubData.inventoryMobileData) : [],
            inventoryCtvData: initialPubData.inventory_type_select.includes("CTV / FAST Apps") ? JSON.stringify(initialPubData.inventoryCtvData) : [],

            //keys to replace / update

            regulation_brand_safety_tool: regulationTool,
            regulation_brand_safety_regulator: regulationParameter,
            regulation_brand_safety_regulator_other:
                regulationParameterOther,
        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (

            regulationTool !== "" &&
            // regulationAdserver !== "" &&
            regulationParameter.length !== 0 &&
            (regulationParameter.includes("Others") ? regulationParameterOther.trim() !== "" : true)

        ) {
            if (
                regulationToolIsRequiredError === false &&
                // regulationAdserverIsRequiredError === false &&
                regulationParameterIsRequiredError === false &&
                (regulationParameter.includes("Others") ? regulationParameterOtherIsRequiredError === false : true)
            ) {
                // let formData = new FormData();
                // formData.append("regulation_brand_safety_tool", regulationTool);
                // // formData.append("regulation_brand_safety_adserver", regulationAdserver);
                // formData.append("regulation_brand_safety_regulator", JSON.stringify(regulationParameter));
                // formData.append("regulation_brand_safety_regulator_other", regulationParameterOther);

                const finalPayload = buildFinalPayload();
                if (!finalPayload) return;

                const formData = objectToFormData(finalPayload);


                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                window.location.reload()
                            }, 1500)


                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });

                }





            }
        } else {
            if (regulationTool === "") {
                setRegulationToolIsRequiredError(true);
            }
            // if (regulationAdserver === "") {
            //     setRegulationAdserverIsRequiredError(true);
            // }
            if (regulationParameter.length === 0) {
                setRegulationParameterIsRequiredError(true);
            }
            if (regulationParameter.includes("Others") && regulationParameterOther.trim() === "") {
                setRegulationParameterOtherIsRequiredError(true);
            }
        }
    };





    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between">
                <h1 className="heading fw_600"> Brand Safety </h1>
                {!buttonValue ?
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 4rem' }} onClick={handleSubmit} disabled={!isDirty}>
                        <span>Save</span>
                    </button>
                    :
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 3rem' }}>
                        <span>
                            Processing...
                        </span>
                    </button>
                }
            </div>
            <div className="d_flex justify_content_between w_100 mb_10">
                <div className="radios_btns --radios_btns_new">
                    <Radio.Group
                        value={tab}
                        className='radio_btn--group mb-0'>
                        <Radio.Button value="iab" onClick={() => { window.location.replace("/brandSafety") }}>IAB Category Blocking</Radio.Button>
                        <Radio.Button value="basicsettings">Basic Settings</Radio.Button>
                    </Radio.Group>
                </div>

            </div>
            <div className="container_box--form-container bg-transparent border-0 p-0">
                <div className="container_box--width">
                    {/* <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Regulation & Brand Safety</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container mb-0">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which anti-fraud tools do you use? (Pixalate, MOAT, etc.)</label>
                                            <Input className="form_control basic" />
                                        </div>

                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">Which regulatory parameters you support ?</label>
                                            <Checkbox.Group className="form_checkbox equal_space">
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                    value="GDPR">
                                                    GDPR
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="COPPA">
                                                    COPPA
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="US Privacy">
                                                    US Privacy
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="TCF">
                                                    TCF
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn withoutchecked w-100 checkbox_with_input_design" value="Others">
                                                    Others
                                                    <Input className='form_control basic' placeholder='Enter here' autoComplete="off" />
                                                </Checkbox>
                                            </Checkbox.Group>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row> */}

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Regulation & Brand Safety</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container mb-0"
                            // ref={regulationDetailsRef}
                            >
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which anti-fraud tools do you use? (e.g., DoubleVerify, Human, or other providers) *</label>
                                            <Input
                                                className={
                                                    regulationToolIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={regulationTool}
                                                onBlur={onBlurRegulationTool}
                                                onChange={onChangeRegulationTool}
                                                // disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className='error_content'>
                                                {regulationToolIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    {/* <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which adserver do you use? (GAM, SpringServe, Publica, etc.) *</label>
                                            <Input
                                                className={
                                                    regulationAdserverIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={regulationAdserver}
                                                onBlur={onBlurRegulationAdserver}
                                                onChange={onChangeRegulationAdserver}
                                                // disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className='error_content'>
                                                {regulationAdserverIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col> */}
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">Which regulatory parameters you support ? *</label>
                                            <Checkbox.Group className="form_checkbox equal_space"
                                                value={regulationParameter} onChange={onChangeRegulationParameter}
                                            // disabled={isDisabled}
                                            >
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="GDPR">
                                                    GDPR
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="COPPA">
                                                    COPPA
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="US Privacy">
                                                    US Privacy
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="TCF">
                                                    TCF
                                                </Checkbox>
                                                <Checkbox className={regulationParameter.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"}
                                                    value="Others">
                                                    Others
                                                    <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                        disabled={(!regulationParameter.includes("Others")
                                                            // || isDisabled
                                                        )}
                                                        value={regulationParameter.includes("Others") ? regulationParameterOther : ""}
                                                        onChange={(e) => {
                                                            setRegulationParameterOther(e.target.value);
                                                            if (e.target.value.trim().length > 0) setRegulationParameterOtherIsRequiredError(false);
                                                        }}
                                                    />
                                                </Checkbox>
                                                {regulationParameter.includes("Others") && regulationParameterOtherIsRequiredError && (
                                                    <span className="error_content">Please provide value for others</span>
                                                )}
                                            </Checkbox.Group>
                                            {regulationParameterIsRequiredError && (
                                                <span className="error_content">This field is required</span>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default BasicSetting;
